import { Box, Typography } from '@mui/material'
import { IFrequencyAssignmentWithCoordinates } from '../../types/exercise.type'
import scss from './styles.module.scss'

interface IProps {
  point: IFrequencyAssignmentWithCoordinates
}

const PointDetails: React.FC<IProps> = ({ point }) => {
  return (
    <div className={scss.tooltip}>
      <p>Serial: {point.id_override}</p>
      <p>
        Request range: {point.request_frequency_single_start_freq}
        {point.request_frequency_single_end_indicator} - {point.request_frequency_single_end_freq}
        {point.request_frequency_single_end_indicator}
      </p>
      <p>
        Location: {point.request_location_latitude_deg}&deg;
        {point.request_location_latitude_min}'{point.request_location_latitude_sec}"{' '}
        {point.request_location_longitude_deg}&deg;
        {point.request_location_longitude_min}'{point.request_location_longitude_sec}"
      </p>
      <p>Radius: {point.request_location_radius}</p>
      <p>Transmitter Location: {point.request_location_transmitter_location}</p>
      <p>State: {point.state_region_type_name}</p>
      <p>511 Type: {point.major_function_511_name}</p>
      <p>Assigned Frequency: {point.request_frequency_value}</p>
      <p>Assigned Frequency Serial #: {point.request_assigned_frequency_list_serial_number}</p>
      <p>Emission Code: {point.f_114}</p>
      <p>Exercise: {point.exercise_name}</p>
      <p>Start Date: {point?.exercise_start_date?.format('YYYY-MM-DD')}</p>
      <p>End Date: {point?.exercise_end_date?.format('YYYY-MM-DD')}</p>

      {point?.affectedCountries?.length && <p>Affected Countries:</p>}
      <Box className={scss.countries}>
        {point?.affectedCountries?.map(({ country, flag }) => (
          <Box key={country} className={scss.country}>
            <img className={scss.flag} src={flag} alt={`${country} flag`} />
            <Typography className={scss.name}>{country}</Typography>
          </Box>
        ))}
      </Box>
    </div>
  )
}

export default PointDetails
